import type { RemarketingTagParams } from '~~/types/integrations/tagManager/RemarketingTagParams';

export const buildRemarketingTags = (tagsForRemarketing: RemarketingTagParams) => ({
  event: 'remarketingTriggered',
  google_tag_params: tagsForRemarketing,
});
